import { useQuery } from '@tanstack/react-query';
import { questKeys } from '../quests.keys';
import { hasQuestBeenClaimed } from '../quests.service';
export const useHasQuestBeenClaimed = (questId) => {
    return useQuery({
        queryKey: questKeys.hasQuestBeenClaimed(questId),
        queryFn: () => hasQuestBeenClaimed(questId),
        enabled: !!questId,
    });
};
